import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import storage from "./utils/storage";
import { getParams } from "./utils/authUtils";
import Swal from "sweetalert2";
import ScrollToTop from "./components/ScrollToTop";

import Loader from "./components/Loader";
import Unauthorized from "./pages/Unauthorized";
import Dashboard from "./pages/Home/Dashboard";
import LeadService from "./services/LeadService";

function App() {
  const [loading, setLoading] = useState(false);
  const [authorized, setAuthorized] = useState(true);
  const [isUser, setIsUser] = useState(null);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = async () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const authorization = params.get("authorization");

    if (!authorization) {
      setAuthorized(false);
      return;
    }
  };

  if (loading || authorized === null) return <Loader />;

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {!authorized && <Route path="*" element={<Unauthorized />} />}

        {authorized && (
          <>
            <Route path="/" element={<Dashboard />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
